import { guides } from '../guides';
import SectionHead from './SectionHead';

export default function LocalGuides({
  exclude,
  limit
}: {
  exclude?: string;
  limit?: number;
}) {
  return (
    <section
      id="guides"
      className="scroll-mt-20 border-y border-forest/10 bg-glacial-light/40"
    >
      <div className="mx-auto max-w-6xl px-4 py-14">
        <SectionHead
          title={exclude ? 'More from the local guide' : 'Explore Garden Bay'}
          subtitle="Lake days, forest trails and unhurried weekends on the Sunshine Coast. A little inspiration for your stay."
        />
        <div
          className={`grid gap-6 ${exclude ? 'sm:grid-cols-2' : 'sm:grid-cols-2 lg:grid-cols-3'}`}
        >
          {guides
            .filter((guide) => guide.slug !== exclude)
            .slice(0, limit)
            .map((guide) => (
              <a
                key={guide.slug}
                href={guide.href}
                className="group flex flex-col rounded-2xl border border-forest/15 bg-birch p-6 transition hover:border-forest/40 hover:bg-white focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-4"
              >
                <span className="text-xs font-semibold uppercase tracking-widest text-bark/65">
                  {guide.category}
                </span>
                <h3 className="mt-4 font-display text-3xl font-semibold leading-tight text-forest">
                  {guide.title}
                </h3>
                <p className="mt-4 text-bark/75">{guide.description}</p>
                <span className="mt-auto pt-6 text-sm font-semibold text-forest">
                  Read the guide <span aria-hidden="true">&rarr;</span>
                </span>
              </a>
            ))}
        </div>
        {limit !== undefined && (
          <a
            href="/guides/"
            className="mt-8 inline-block rounded-xl bg-forest px-5 py-3 text-sm font-semibold text-white hover:bg-forest-hover focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-4"
          >
            All local guides <span aria-hidden="true">&rarr;</span>
          </a>
        )}
      </div>
    </section>
  );
}
